<template>
  <div class="Fin" ref="section">
    <div
      class="Fin-animation"
      :class="{ 'animation-triggered': imgVisible }"
    >
      <img
        v-if="imgVisible"
        :src="imgSrc"
        alt="Fin"
        key="fin-img"
        draggable="false"
      />
    </div>
    <!-- 如有需要可加標題，不需要可以刪除 -->
    <!--
    <h1 class="Fin-title">
      <span class="gradient animate-line delay-1">
        產品終章（Fin）
      </span>
      <span class="line-1 animate-line delay-2">
        完美收尾．TSK 新世代尖針
      </span>
    </h1>
    -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgVisible: false,
      hasPlayed: false,
      isMobile: false
    }
  },
  computed: {
    assetBase() {
      return (process.env.VUE_APP_ARTICLE_BASE_URL || '').replace(/\/$/, '')
    },
    imgSrc() {
      return this.isMobile
        ? `${this.assetBase}/mp4/TSN/Fin/Fin_phone.png`
        : `${this.assetBase}/mp4/TSN/Fin/Fin_web.png`
    }
  },
  mounted() {
    this.checkDevice()
    window.addEventListener("resize", this.checkDevice)

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.66 && !this.hasPlayed) {
          this.imgVisible = false // reset for fade in
          this.$nextTick(() => {
            this.imgVisible = true
            this.hasPlayed = true
            observer.disconnect()
          })
        }
      },
      { threshold: [0, 0.33, 0.66, 1] }
    )
    observer.observe(this.$refs.section)
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkDevice)
  },
  methods: {
    checkDevice() {
      const isPortrait = window.innerHeight > window.innerWidth
      const ua = navigator.userAgent
      const isiPad = /iPad/.test(ua) || (ua.includes("Macintosh") && 'ontouchend' in document)
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0

      this.isMobile = isPortrait && (window.innerWidth <= 820 || isiPad || isTouchDevice)
    }
  }
}
</script>

<style scoped>
@keyframes fadeUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.Fin {
/* removed min-height */
/* removed flex */
/* removed justify-content */
/* removed align-items */
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.Fin-animation {
  opacity: 0;
  transition: opacity 0.8s ease;
}
.Fin-animation.animation-triggered {
  opacity: 1;
}

.Fin-animation img {
  width: 100%;
  /* max-height removed */
  height: auto;
  display: block;
}
</style>
